module.exports = __webpack_public_path__ + "static/media/certifications.f0ae5681.png";